import React from 'react';

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-white py-32" data-testid="terms-page">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="text-5xl font-bold mb-4">Terms &amp; Conditions</h1>
        <p className="text-sm text-gray-500 mb-2">Last Updated: March 2026</p>
        <p className="text-sm text-gray-600 mb-8">
          <strong>ZenStudios Private Limited</strong> | CIN: U68100TS2025PTC208253 | GSTIN: 36AAECO9870D1Z7<br />
          Registered Office: Hyderabad, Telangana, India
        </p>

        <div className="space-y-8 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">1. Acceptance of Terms</h2>
            <p>By accessing and using ZenStudios&apos; platform and services (the &quot;Platform&quot;), you (&quot;User&quot;) accept and agree to be bound by these Terms and Conditions (&quot;Terms&quot;). If you do not agree to these Terms, you must not use our Platform. These Terms constitute a legally binding agreement between you and ZenStudios Private Limited (&quot;ZenStudios&quot;, &quot;Company&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;).</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">2. Company Information</h2>
            <ul className="list-disc ml-6 mt-2 space-y-2">
              <li><strong>Legal Entity:</strong> ZenStudios Private Limited</li>
              <li><strong>CIN:</strong> U68100TS2025PTC208253</li>
              <li><strong>GSTIN:</strong> 36AAECO9870D1Z7</li>
              <li><strong>Registered Office:</strong> Hyderabad, Telangana, India</li>
              <li><strong>Email:</strong> info@zenstudios.in</li>
              <li><strong>Phone:</strong> +91-8790460259</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">3. Services Offered</h2>
            <p>ZenStudios provides the following services through its Platform:</p>
            <ul className="list-disc ml-6 mt-2 space-y-2">
              <li><strong>Real Estate Brokerage &amp; Listings:</strong> Property buying, selling, renting, leasing, and PG listing services in compliance with the Real Estate (Regulation and Development) Act, 2016 (RERA)</li>
              <li><strong>Interior Design Services:</strong> AI-powered cost estimation, design consultation, and project execution for residential, commercial, corporate, healthcare, and hospitality spaces</li>
              <li><strong>Property Management Services:</strong> Full property management, rental management, and maintenance coordination</li>
              <li><strong>Subscription Services:</strong> Tiered subscription packages for Real Estate Agents/Channel Partners and Builders/Developers</li>
              <li><strong>Legal Services:</strong> Property-related legal opinion, documentation, and verification services</li>
              <li><strong>Home Loan Assistance:</strong> Facilitation of home loan applications with partner banks and NBFCs</li>
              <li><strong>Priest &amp; Vastu Services:</strong> Coordination of religious ceremonies and vastu consultations related to property</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">4. User Eligibility &amp; Registration</h2>
            <p>To use our services, you must:</p>
            <ul className="list-disc ml-6 mt-2 space-y-2">
              <li>Be at least 18 years of age and legally competent to enter into a binding contract under the Indian Contract Act, 1872</li>
              <li>Provide accurate, complete, and current information during registration</li>
              <li>Maintain the confidentiality of your account credentials</li>
              <li>Not operate more than one account without prior approval</li>
              <li>Hold valid KYC documentation as required under the Prevention of Money Laundering Act (PMLA), 2002 for property transactions</li>
            </ul>
            <p className="mt-2">Real estate agents and developers must hold valid RERA registration as applicable to their state of operation.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">5. Property Listings &amp; RERA Compliance</h2>
            <ul className="list-disc ml-6 mt-2 space-y-2">
              <li>All property listings must comply with the Real Estate (Regulation and Development) Act, 2016</li>
              <li>Properties under development must display valid RERA registration numbers as mandated by the respective State RERA Authority</li>
              <li>Developers/builders must provide accurate project details including carpet area (as defined under RERA), floor plans, and approvals</li>
              <li>ZenStudios does not guarantee the accuracy of listings posted by third-party agents, developers, or individual sellers. Users are advised to independently verify all property details</li>
              <li>Misleading or fraudulent listings will be immediately removed and may result in permanent account suspension and legal action</li>
              <li>Listing content must comply with the Advertising Standards Council of India (ASCI) guidelines for real estate advertising</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">6. Subscription &amp; Pricing Terms</h2>
            <p><strong>Agent/Channel Partner Subscriptions:</strong></p>
            <ul className="list-disc ml-6 mt-2 space-y-2">
              <li>Available in tiered plans: Ignite, Momentum, Accelerate, Dominate, and Rule</li>
              <li>Subscriptions are available on monthly, semi-annual, and annual billing cycles</li>
              <li>Features and limits are governed by the specific tier selected</li>
            </ul>
            <p className="mt-4"><strong>Developer/Builder Subscriptions:</strong></p>
            <ul className="list-disc ml-6 mt-2 space-y-2">
              <li>Available in tiered plans with project limits as specified in the plan details</li>
              <li>Enterprise plans with custom pricing are available for large developer groups</li>
            </ul>
            <p className="mt-2">All prices are in Indian Rupees (INR) and are subject to applicable Goods and Services Tax (GST) at the prevailing rate (currently 18% for technology services).</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">7. Payment Terms</h2>
            <ul className="list-disc ml-6 mt-2 space-y-2">
              <li>Payments are processed through Razorpay payment gateway, which is PCI-DSS compliant</li>
              <li>Property listing fees and subscription fees are payable in advance</li>
              <li>Interior design services require advance booking payment as specified in the consultation quote</li>
              <li>Property management fees are charged on a monthly basis as per the service agreement</li>
              <li>All transactions are subject to applicable GST as per the Goods and Services Tax Act, 2017</li>
              <li>TDS provisions under Section 194-IA of the Income Tax Act, 1961 apply to applicable property transactions</li>
              <li>Payment receipts and GST-compliant invoices will be generated for all transactions</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">8. Quote Estimates (Interior Design)</h2>
            <p>All interior design quotes generated through our platform are <strong>estimates only</strong>. Final costs may vary based on:</p>
            <ul className="list-disc ml-6 mt-2 space-y-2">
              <li>Actual material selection and prevailing market prices</li>
              <li>Site conditions, accessibility, and structural requirements</li>
              <li>Design modifications requested by the client after initial agreement</li>
              <li>Applicable taxes, duties, and regulatory compliance costs</li>
            </ul>
            <p className="mt-2">A detailed, binding quote will be provided after site inspection and design finalization. All design work is executed as per the terms of the specific design agreement signed between the parties.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">9. Cancellation &amp; Refund Policy</h2>
            <p><strong>Property Listings:</strong> Listing fees are non-refundable once the property is published on the Platform.</p>
            <p className="mt-2"><strong>Subscription Services:</strong> Subscriptions may be cancelled before the next billing cycle. No pro-rata refunds are provided for the remaining period of the current billing cycle. Downgrade or upgrade requests will take effect from the next billing cycle.</p>
            <p className="mt-2"><strong>Interior Design Services:</strong> Cancellation allowed within 48 hours of booking with a 50% refund. No refund once design work commences.</p>
            <p className="mt-2"><strong>Property Management:</strong> One calendar month notice is required for service termination.</p>
            <p className="mt-2"><strong>Boost/Add-on Services:</strong> Boost listing and add-on purchases are non-refundable once activated.</p>
            <p className="mt-2">All refunds, if applicable, will be processed within 7-10 business days to the original payment method, as per RBI guidelines on refund processing.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">10. Data Protection &amp; Privacy</h2>
            <ul className="list-disc ml-6 mt-2 space-y-2">
              <li>We are committed to protecting your privacy in accordance with the Digital Personal Data Protection Act, 2023 (DPDP Act)</li>
              <li>Personal data is collected and processed only for specified, lawful purposes with user consent</li>
              <li>We implement appropriate technical and organizational security measures to protect personal data</li>
              <li>Users have the right to access, correct, and request deletion of their personal data as per the DPDP Act</li>
              <li>Data localization: All personal data of Indian users is stored on servers located within India, as per applicable regulations</li>
              <li>Please refer to our Privacy Policy for detailed information on data handling practices</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">11. Intellectual Property</h2>
            <p>All design concepts, plans, materials, software, logos, trademarks, and content created by or on behalf of ZenStudios remain the exclusive intellectual property of ZenStudios Private Limited, protected under the Copyright Act, 1957 and the Trade Marks Act, 1999. Unauthorized use, reproduction, or distribution is prohibited and may result in legal action.</p>
            <p className="mt-2">Design deliverables under interior design services will be licensed to the client upon receipt of full payment as per the specific project agreement.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">12. Anti-Money Laundering (AML) Compliance</h2>
            <p>In compliance with the Prevention of Money Laundering Act (PMLA), 2002 and guidelines issued by the Financial Intelligence Unit (FIU-IND):</p>
            <ul className="list-disc ml-6 mt-2 space-y-2">
              <li>Users may be required to provide KYC documentation for property transactions</li>
              <li>Suspicious transactions may be reported to the relevant authorities</li>
              <li>ZenStudios reserves the right to refuse or freeze accounts where AML concerns arise</li>
              <li>All property transactions above the threshold prescribed under PMLA must be conducted through banking channels only</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">13. Limitation of Liability</h2>
            <p>ZenStudios shall not be liable for:</p>
            <ul className="list-disc ml-6 mt-2 space-y-2">
              <li>Any indirect, incidental, special, or consequential damages arising from the use of our services</li>
              <li>Delays or non-performance caused by force majeure events or circumstances beyond our reasonable control</li>
              <li>Actions, omissions, or representations of third-party service providers, agents, developers, or sellers</li>
              <li>Fluctuations in property prices, material costs, or market conditions</li>
              <li>Loss of data due to technical failures, provided we have taken reasonable precautions</li>
            </ul>
            <p className="mt-2">Our total liability in any claim shall not exceed the amount paid by the User for the specific service giving rise to the claim in the preceding 12 months.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">14. Indemnification</h2>
            <p>You agree to indemnify and hold harmless ZenStudios, its directors, officers, employees, and agents from any claims, damages, losses, or expenses arising from your use of the Platform, violation of these Terms, or infringement of any third-party rights.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">15. Dispute Resolution</h2>
            <ul className="list-disc ml-6 mt-2 space-y-2">
              <li>Any dispute arising out of or in connection with these Terms shall first be attempted to be resolved through amicable negotiation</li>
              <li>If unresolved within 30 days, the dispute shall be referred to arbitration under the Arbitration and Conciliation Act, 1996</li>
              <li>The arbitration shall be conducted by a sole arbitrator appointed mutually, with the seat of arbitration in Hyderabad, Telangana</li>
              <li>The language of arbitration proceedings shall be English</li>
              <li>For consumer disputes, users may also approach the Consumer Disputes Redressal Commission as per the Consumer Protection Act, 2019</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">16. Governing Law &amp; Jurisdiction</h2>
            <p>These Terms shall be governed by and construed in accordance with the laws of India. Subject to the arbitration clause above, any legal proceedings arising out of these Terms shall be subject to the exclusive jurisdiction of the courts in Hyderabad, Telangana.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">17. Modifications to Terms</h2>
            <p>ZenStudios reserves the right to modify these Terms at any time. Material changes will be notified via email or prominent notice on the Platform at least 15 days before the effective date. Continued use of our services after the effective date of modifications constitutes acceptance of the updated Terms.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">18. Grievance Redressal</h2>
            <p>In accordance with the Information Technology Act, 2000 and rules made thereunder, the Grievance Officer for ZenStudios is:</p>
            <div className="bg-gray-50 p-4 rounded-lg mt-2">
              <p><strong>Grievance Officer</strong></p>
              <p>ZenStudios Private Limited</p>
              <p>Hyderabad, Telangana, India</p>
              <p><strong>Email:</strong> grievance@zenstudios.in</p>
              <p><strong>Phone:</strong> +91-8790460259</p>
              <p className="text-sm text-gray-500 mt-2">Grievances will be acknowledged within 24 hours and resolved within 15 business days of receipt.</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">19. Contact Information</h2>
            <p>For questions about these Terms or our services, please contact us at:</p>
            <div className="bg-gray-50 p-4 rounded-lg mt-2">
              <p><strong>ZenStudios Private Limited</strong></p>
              <p>CIN: U68100TS2025PTC208253</p>
              <p>GSTIN: 36AAECO9870D1Z7</p>
              <p className="mt-2"><strong>Email:</strong> info@zenstudios.in</p>
              <p><strong>Legal:</strong> legal@zenstudios.in</p>
              <p><strong>Phone:</strong> +91-8790460259</p>
              <p><strong>Address:</strong> Hyderabad, Telangana, India</p>
            </div>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} ZenStudios Private Limited. All rights reserved.</p>
          <p className="mt-1">CIN: U68100TS2025PTC208253 | GSTIN: 36AAECO9870D1Z7</p>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
